import {AssetLunarExchangeOptionPutDataTransferObject} from "../../data-transfer-object/asset/AssetLunarExchangeOptionPutDataTransferObject"

/**
 * 루나 교환 옵션 속성 설명
 */
export const AssetLunarExchangeOptionPutDataTransferObjectDescription: Record<keyof AssetLunarExchangeOptionPutDataTransferObject, string> = {
    lunarAmount: '지급 루나',
    solarAmount: '소모 솔라'
}
